import React, { useState, useEffect } from "react";
import { useJobProvider } from "../../../../Providers/Consultant/Jobs";
import moment from "moment";
import { useTimesheetProvider } from "../../../../Providers/Consultant/Timesheet";
import { Button } from "antd";
import { useNavigate, useParams } from "react-router-dom";

export default function OngoingJobInformation({ jobId, reset, setActive, setDetailedTimesheet }) {
  const [job, setJob] = useState({});
  const [isExpanded, setIsExpanded] = useState(false);
  const { fetchJobDetails } = useJobProvider();
  const { setSelectedJobDetails, setSelectedTimesheet } = useTimesheetProvider()

  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  const { id } = useParams()

  const navigate = useNavigate()

  useEffect(() => {
    fetchJobDetails(id).then((data) => setJob(data));
  }, []);

  return (
    <div>
      <div className="flex flex-col bg-white rounded-lg font-[Roboto] p-4 space-y-3">
        <span className="cursor-pointer mb-4" onClick={() => {
          navigate("/dashboard/my-jobs")
        }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
            />
          </svg>
        </span>
        <span className="flex flex-row items-center text-gray-700">
          <span className="mr-2 font-medium">Title:</span>
          <span>{job?.name}</span>
        </span>
        <span className="flex flex-row text-gray-700">
          <span className="mr-2 font-medium">Description:</span>
          <div className="flex flex-col space-y-1">
            <div className="text-justify">
              {isExpanded ? job?.description?.split(' ')?.join(' ') : job?.description?.split(' ')?.slice(0, 70)?.join(' ')}
            </div>
            {job?.description?.split(' ').length >= 70 && <div className="flex flex-row justify-start">
              <button type="button" className="text-blue-400" onClick={toggleExpand}>
                {isExpanded ? "See Less" : "See More"}
              </button>
            </div>}
          </div>
        </span>
        <span className="flex flex-row items-center text-gray-700">
          <span className="mr-2 font-medium">Skills:</span>
          <span className="space-x-3">
            {job?.main_skill?.map((skill) => {
              return (
                <span className="text-justify text-sm py-0.5 px-1 text-[#139588] w-[83px] h-[25px] border-[1px] border-[#139588]">
                  {skill}
                </span>
              );
            })}
            {!job?.main_skill && "No Skills Provided"}
          </span>
        </span>
        <span className="flex justify-between text-gray-700">
          <span className="font-medium">
            Location: <span className="font-normal">{job?.location}</span>
          </span>
          <span className="font-medium">
            Start Date:{" "}
            <span className="font-normal">
              {job?.start_date
                ? moment.utc(job.start_date, "YYYY-MM-DD").format("DD/MM/YYYY")
                : null}
            </span>
          </span>
          <span />
        </span>
        {job?.location !== "REMOTE" &&
          <div className="flex flex-row justify-between">
            <span className="font-medium">
              Country: <span className="font-normal ml-2">{job?.country}</span>
            </span>
            <span className="font-medium">
              State: <span className="font-normal ml-2">{job?.state}</span>
            </span>
            <span className="font-medium">
              City: <span className="font-normal ml-2">{job?.city}</span>
            </span>
          </div>}
      </div>
      <div className="mt-4">
        <Button
          type="primary"
          className="bg-[#2EBAA3]" onClick={() => {
            navigate(`/dashboard/timesheets/${id}`)
          }}>Create Timesheet</Button>
      </div>
    </div>
  );
}
